import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useNetworkManager } from "../../../game-manager/network-manager";
import { JoinRoomForm } from "../../../game-manager/network-manager/hooks/useRooms";
import AuthService from "../../../../services/auth.service";

import {
  Container,
  Title,
  Body,
  Button,
  ControlWrapper,
  ErrorWrapper,
} from "../ui/styles";

import {
  StyledBody,
  GameItems,
  ItemWrapper,
  Item,
  ItemSection,
  ItemLabel,
} from "./styles";

//components
import { IError } from "../../../game-manager/network-manager/types";

interface Props {}


const getErrorMessage = (error: IError) => {
  const { errorType, payload } = error;

  switch (errorType) {
    case "PASSWORD_NOT_PRESENT":
      return `There was no password for room named: ${payload.roomName}`;
    case "PASSWORD_NOT_VALID":
      return `Password for room '${payload.roomName}' was not valid. Please try again.`;
    default:
      return "Some error happened";
  }
};

const JoinGameComponent: React.FC<Props> = () => {
  const history = useHistory()
  const [expandedRoomId, setExpandedRoom] = useState<string | undefined>(
    undefined
  );
  const { emitterService, roomsService } = useNetworkManager();
  const [username, setUsername] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [ message, setMessage ]  = useState("");

  const {
    rooms,
    isLoading,
    isJoiningRoom,
    updateJoinRoomForm,
    joinRoomForm,
    setIsJoiningRoom,
    error,
  } = roomsService;

  useEffect(() => {
    // const user = AuthService.getCurrentUser();
    setUsername(AuthService.getCurrentUser()?.username);
    setAccessToken(AuthService.getCurrentUser()?.accessToken);
    emitterService.getRooms();
    console.log(!username);
    roomsService.setIsJoiningRoom(false);
    roomsService.setError(undefined);
    console.log("this is a join room");
    console.log(rooms);
  }, []);

  const syncField = (key: keyof JoinRoomForm, value: string) => {
    updateJoinRoomForm({
      ...joinRoomForm,
      [key]: value,
    });
  };

  const onJoin = (roomId: string) => {
    console.log("trying to join", roomId);
    setIsJoiningRoom(true);

    emitterService.joinRoom(roomId, username as string, accessToken as string);
  };

  const checkLogedIn = () => {
    if(username) {
      
    }
  }
  const isJoinDisabled =
    (!username) || isJoiningRoom;

  const errorMessage = error === undefined ? undefined : getErrorMessage(error);

  return (
    <Container>
      {message && (
        <div className="form-group">
          <div
            className={
              username ? "alert alert-success" : "alert alert-danger"
            }
            role="alert"
          >
            {message}
          </div>
        </div>
      )}
      <Title>Available Rooms ({isLoading ? "Loading" : "Up to date"})</Title>
      <StyledBody>
        <GameItems>
          {rooms.map((game) => (
            <ItemWrapper key={game.id} isExpanded={expandedRoomId === game.id}>
              <Item
                onClick={() => 
                  {
                    if(username) {
                      setExpandedRoom((current) =>
                        current !== game.id ? game.id : undefined
                      )
                    } else {
                      setMessage("Please, Login first");
                      history.push("/login");
                    }
                  }
                }
              >
                <ItemSection>
                  <ItemLabel>{game.name}</ItemLabel>
                  {(game.status === "ROOM_CREATED") && 
                  <ItemLabel>0/2</ItemLabel>
                  }
                  {(game.status === "WAITING_FOR_GUEST") && 
                  <ItemLabel>1/2</ItemLabel>
                  }
                </ItemSection>
              </Item>

              {game.id === expandedRoomId && (
                <Container>
                  <Body>
                    {errorMessage && (
                      <ControlWrapper>
                        <ErrorWrapper>{errorMessage}</ErrorWrapper>
                      </ControlWrapper>
                    )}
                    <ControlWrapper style={{ flexDirection: "row-reverse" }}>
                      <Button
                        style={{ height: "32px" }}
                        disabled={isJoinDisabled}
                        onClick={() => onJoin(game.id)}
                      >
                        {isJoiningRoom
                          ? "Joining Room"
                          : `Join Room ${game.name}`}
                      </Button>
                    </ControlWrapper>
                  </Body>
                </Container>
              )}
            </ItemWrapper>
          ))}
        </GameItems>
      </StyledBody>
    </Container>
  );
};

export default JoinGameComponent;
